import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import {
  Container, Row, Col, Card, CardBody, Spinner, Button,
} from 'reactstrap'
import moment from 'moment'
import { currencyFormatter } from '../../../utils/currencyFormatter'
import AddContract from '../../../components/Modal/AddContract'
import DataTable from '../../../components/Template/Table/DataTable'
import Select from '../../../components/Template/Input/Select'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { listBids } from '../../../store/ducks/comercial'

class Public extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dateFilter: null,
      addContractModalIsOpen: false,
      addContractDataDraft: {},
    }
  }

  componentDidMount() {
    const { listBids } = this.props

    listBids()
  }

  renderActionsButton = (bid) => {
    if (
      bid.fields.Vencedor === 'ECOSSIS SOLUCOES AMBIENTAIS S/S LTDA'
      && bid.fields.Situa_x00e7__x00e3_o === 'Homologado'
    ) {
      return (
        <Button
          color="primary"
          size="sm"
          outline
          onClick={() => this.setState({
            addContractModalIsOpen: true,
            addContractDataDraft: bid,
          })}
        >
          Cadastrar contrato
        </Button>
      )
    }

    return ''
  }

  render() {
    const {
      dateFilter, addContractModalIsOpen, addContractDataDraft,
    } = this.state

    const {
      bids, listBidsIsLoading,
    } = this.props.comercial

    //const { isManager } = this.props.auth.user

    //if (!isManager) return <Redirect to="/" />

    if (listBidsIsLoading) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }


    let bidsReduced = []
    let filteredBids = []
    if (!listBidsIsLoading && bids) {
      filteredBids = bids

      // Filter by Date
      if (dateFilter) {
        switch (dateFilter) {
          case 'Hoje': {
            filteredBids = filteredBids.filter(b => (
              moment(b.fields.Abertura).isSame(moment(), 'day')
            ))
            break
          }
          case 'Este mês': {
            filteredBids = filteredBids.filter(b => (
              moment(b.fields.Abertura).isSame(moment(), 'month')
            ))
            break
          }

          case 'Próximos 7 dias': {
            filteredBids = filteredBids.filter(b => (
              moment(b.fields.Abertura).isBetween(moment().add(1, 'days'), moment().add(7, 'days'))
            ))
            break
          }
          case 'Próximos 30 dias': {
            filteredBids = filteredBids.filter(b => (
              moment(b.fields.Abertura).isBetween(moment().add(1, 'days'), moment().add(30, 'days'))
            ))
            break
          }
          case 'Próximo mês': {
            filteredBids = filteredBids.filter(b => (
              moment(b.fields.Abertura).isSame(moment().add(1, 'month'), 'month')
            ))
            break
          }
          case 'Próximos 3 meses': {
            filteredBids = filteredBids.filter(b => (
              moment(b.fields.Abertura).isBetween(moment().endOf('month').add(1, 'month'), moment().startOf('month').add(3, 'month'))
            ))
            break
          }
          case 'Próximos 6 meses': {
            filteredBids = filteredBids.filter(b => (
              moment(b.fields.Abertura).isBetween(moment().endOf('month').add(1, 'month'), moment().startOf('month').add(6, 'month'))
            ))
            break
          }

          case 'Últimos 7 dias': {
            filteredBids = filteredBids.filter(b => (
              moment(b.fields.Abertura).isBetween(moment().subtract(8, 'days'), moment().subtract(1, 'days'))
            ))
            break
          }
          case 'Últimos 30 dias': {
            filteredBids = filteredBids.filter(b => (
              moment(b.fields.Abertura).isBetween(moment().subtract(31, 'days'), moment().subtract(1, 'days'))
            ))
            break
          }
          case 'Último mês': {
            filteredBids = filteredBids.filter(b => (
              moment(b.fields.Abertura).isSame(moment().subtract(1, 'month'), 'month')
            ))
            break
          }
          case 'Últimos 3 meses': {
            filteredBids = filteredBids.filter(b => (
              moment(b.fields.Abertura).isBetween(moment().startOf('month').subtract(3, 'month'), moment().endOf('month').subtract(1, 'month'))
            ))
            break
          }
          case 'Últimos 6 meses': {
            filteredBids = filteredBids.filter(b => (
              moment(b.fields.Abertura).isBetween(moment().startOf('month').subtract(6, 'month'), moment().endOf('month').subtract(1, 'month'))
            ))
            break
          }
          default: break
        }
      }
    }

    // Get statistics
    bidsReduced = [
      {
        label: 'Todas',
        sum: '',
        count: filteredBids.length,
      },
      {
        label: 'A cadastrar',
        sum: '',
        count: filteredBids.filter(bid => bid.fields.Status0 === 'A cadastrar').length,
      },
      {
        label: 'Em Análise',
        sum: '',
        count: filteredBids.filter(bid => bid.fields.Status0 === 'Em Análise').length,
      },
      {
        label: 'Em Elaboração',
        sum: '',
        count: filteredBids.filter(bid => bid.fields.Status0 === 'Em Elaboração').length,
      },
      {
        label: 'Encaminhada',
        sum: currencyFormatter.format(filteredBids
          .filter(bid => bid.fields.Status0 === 'Encaminhada')
          .reduce((total = 0, current) => {
            if (typeof total === 'object') return (total.fields.Valor || 0) + (current.fields.Valor || 0)
            return total + (current.fields.Valor || 0)
          }, 0)),
        count: filteredBids.filter(bid => bid.fields.Status0 === 'Encaminhada').length,
      },
      {
        label: 'Em contratação',
        sum: currencyFormatter.format(filteredBids
          .filter(bid => bid.fields.Status0 === 'Em contratação')
          .reduce((total = 0, current) => {
            if (typeof total === 'object') return (total.fields.Valor || 0) + (current.fields.Valor || 0)
            return total + (current.fields.Valor || 0)
          }, 0)),
        count: filteredBids.filter(bid => bid.fields.Status0 === 'Em contratação').length,
      },
      {
        label: 'Contratada',
        sum: currencyFormatter.format(filteredBids
          .filter(bid => bid.fields.Status0 === 'Contratada')
          .reduce((total = 0, current) => {
            if (typeof total === 'object') return (total.fields.Valor || 0) + (current.fields.Valor || 0)
            return total + (current.fields.Valor || 0)
          }, 0)),
        count: filteredBids.filter(bid => bid.fields.Status0 === 'Contratada').length,
      },
    ]

    return (
      <div className="page-content">
        <AddContract
          isOpen={addContractModalIsOpen}
          type="public"
          addContractDataDraft={addContractDataDraft}
          toggle={() => {
            this.setState({
              addContractModalIsOpen: false,
              addContractDataDraft: {},
            })

            this.componentDidMount()
          }}
        />

        <Container fluid>
          <Breadcrumbs
            title="Comercial Público"
            breadcrumbItems={[]}
          />

          <Row className="mb-3">
            <Col>
              <h4>
                Licitações
              </h4>
            </Col>

            <Col xl={2} lg={3} md={4} sm={4}>
              <Select
                isClearable
                placeholder="Data de abertura"
                options={[
                  {
                    value: 'Hoje',
                    label: 'Hoje',
                  },
                  {
                    value: 'Este mês',
                    label: 'Este mês',
                  },

                  {
                    value: 'Próximos 7 dias',
                    label: 'Próximos 7 dias',
                  },
                  {
                    value: 'Próximos 30 dias',
                    label: 'Próximos 30 dias',
                  },
                  {
                    value: 'Próximo mês',
                    label: 'Próximo mês',
                  },
                  {
                    value: 'Próximos 3 meses',
                    label: 'Próximos 3 meses',
                  },
                  {
                    value: 'Próximos 6 meses',
                    label: 'Próximos 6 meses',
                  },

                  {
                    value: 'Últimos 7 dias',
                    label: 'Últimos 7 dias',
                  },
                  {
                    value: 'Últimos 30 dias',
                    label: 'Últimos 30 dias',
                  },
                  {
                    value: 'Último mês',
                    label: 'Último mês',
                  },
                  {
                    value: 'Últimos 3 meses',
                    label: 'Últimos 3 meses',
                  },
                  {
                    value: 'Últimos 6 meses',
                    label: 'Últimos 6 meses',
                  },
                ]}
                onChange={selected => this.setState({ dateFilter: selected?.value || null })}
              />
            </Col>
          </Row>

          {bidsReduced && bidsReduced.length > 0 && (
            <Row className="ml-0 mr-0 mb-4 mt-4">
              {bidsReduced.map(i => (
                this.renderStep({ label: i.label, count: i.count, sum: i.sum })
              ))}
            </Row>
          )}

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <DataTable
                    data={{
                      columns: [
                        {
                          label: 'ID',
                          field: 'id',
                          sort: 'desc',
                        },
                        {
                          label: 'Abertura',
                          field: 'openDt',
                        },
                        {
                          label: 'Código',
                          field: 'cod',
                        },
                        {
                          label: 'Un. Licitante',
                          field: 'licitante',
                        },
                        /* {
                          label: 'Modalidade',
                          field: 'type',
                        }, */
                        /* {
                          label: 'Participar?',
                          field: 'participate',
                        }, */
                        /* {
                          label: 'Status',
                          field: 'status',
                        },
                        {
                          label: 'Resultado',
                          field: 'result',
                        },
                        {
                          label: 'Vencedor',
                          field: 'winner',
                        }, */
                        {
                          label: 'Ações',
                          field: 'actions',
                        },
                      ],
                      rows: filteredBids.map(bid => ({
                        id: Number(bid.fields.id),
                        openDt: moment(bid.fields.Abertura).format('DD/MM/YYYY'),
                        cod: bid.fields.Title,
                        licitante: bid.fields.Unidadelicitante,
                        /* type: bid.fields.TipodeLicita_x00e7__x00e3_o, */
                        /* participate: bid.fields.Participar, */
                        /* status: bid.fields.Situa_x00e7__x00e3_o,
                        result: bid.fields.Status_x0020_1,
                        winner: bid.fields.Vencedor, */
                        /* actions: (bid.fields.Vencedor === 'ECOSSIS SOLUCOES AMBIENTAIS S/S LTDA'
                          && bid.fields.Situa_x00e7__x00e3_o === 'Homologado') ? (
                            <Button
                              color="primary"
                              size="sm"
                              outline
                              onClick={() => this.setState({
                                addContractModalIsOpen: true,
                                addContractDataDraft: bid,
                              })}
                            >
                              Cadastrar contrato
                            </Button>
                          ) : '', */
                        actions: this.renderActionsButton(bid),
                      })),
                    }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  comercial: state.comercial,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  listBids,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Public)
